function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M373 310c10 9 10 24 0 33-4 5-10 7-16 7s-12-2-17-7l-54-54-54 54c-4 5-10 7-16 7s-13-2-17-7c-9-9-9-24 0-33l54-54-54-54c-9-9-9-24 0-33s24-9 33 0l54 54 54-54c9-9 24-9 33 0 10 9 10 24 0 33l-54 54zm99-246H127c-14 0-26 7-33 18L4 242c-5 9-5 19 0 28l90 160c7 11 19 18 33 18h345c20 0 36-14 36-32V96c0-18-16-32-36-32z"
}));